<div class="skeletor-card">
  <div class="skeletor-card-header">
    <p-skeleton shape="circle" size="3rem" class="mr-2" />
    <div class="flex-1">
      <p-skeleton width="60%" class="mb-2" />
      <p-skeleton width="40%" />
    </div>
  </div>
  <p-skeleton width="100%" height="150px" class="my-3" />
  <div class="skeletor-card-actions">
    <p-skeleton width="6rem" height="2rem" />
    <p-skeleton width="6rem" height="2rem" />
  </div>
</div>

